export const ATHOM_DEVELOPER_API_CLIENT_ID = '598d85a330e1bb0c0d75b8eb';
export const ATHOM_DEVELOPER_API_CLIENT_SECRET = 'ba93fc861b204732607169fb29c2708f1da7e17f';